/**
 * Canonicalise an enum-like user input to its DB form.
 *
 * Accepts:   "On Hold", "on-hold", "ON_HOLD", " Site Manager "
 * Returns:   "on_hold" / "site_manager"
 *
 * Lowercases, trims, and replaces any run of spaces or hyphens with a single
 * underscore. Non-string or empty inputs are returned unchanged so callers
 * can still detect "missing value" upstream.
 */
export const normalizeEnum = (v) => {
  if (typeof v !== 'string') return v;
  const trimmed = v?.trim();
  if (!trimmed) return trimmed;
  return trimmed?.toLowerCase()?.replace(/[\s-]+/g, '_');
};
